<template>
    <div class="list-col" v-bind:style="style">
        <slot />
    </div>
</template>
<script>
export default {
    name: 'ListCol',
    props: {
        gutter: {
            type: Number
        },
        width: {
            type: Number
        }
    },
    computed: {
        colWidth() {
            return this.width || this.$parent.width;
        },
        colGutter() {
            return this.gutter || this.$parent.gutter;
        },
        style() {
            return {
                width: this.colWidth + this.colGutter + 'px',
                paddingLeft: this.colGutter / 2 + 'px',
                paddingRight: this.colGutter / 2 + 'px'
            };
        }
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.list-col {
    float: left;
}
</style>
